import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useData } from '../contexts/DataContext';
import TabsComponent from '../components/ui/TabsComponent';
import StatusBadge from '../components/ui/StatusBadge';
import CapacityBar from '../components/ui/CapacityBar';
import { db, COLLECTIONS } from '../firebase/config';
import { deleteDoc, doc } from 'firebase/firestore';

import { 
  Plus, 
  Search, 
  Filter, 
  Calendar,
  Users,
  BarChart3,
  FileText,
  ChevronRight,
  AlertCircle,
  CheckCircle,
  Clock,
  XCircle,
  FolderOpen,
  Activity,
  CheckSquare,
  Edit,
  Trash2,
  Info,
  Building2,
  AlertTriangle,
  Globe,
  X,
  List,
  User
} from 'lucide-react';

const Projects = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { currentUser } = useAuth();
  const { projects, tasks, users, departments, teams, createProject, updateProject, updateTask } = useData();
  const [showNewProject, setShowNewProject] = useState(false);
  const [showEditProject, setShowEditProject] = useState(false);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [editProject, setEditProject] = useState(null);
  const [statusProject, setStatusProject] = useState(null);
  const [activeTab, setActiveTab] = useState('overview');
  const [showNewTaskModal, setShowNewTaskModal] = useState(false);
const [newTaskSubtask, setNewTaskSubtask] = useState('');
  const [mainTab, setMainTab] = useState(
    currentUser?.role === 'team_manager' ? 'team' : 
    currentUser?.role === 'employee' ? 'personal' : 'management'
  );
  const [searchTerm, setSearchTerm] = useState('');
  const [filterScope, setFilterScope] = useState('all');
  const [filterStatus, setFilterStatus] = useState('all');
  const [filterPriority, setFilterPriority] = useState('all');
  const [filterDepartment, setFilterDepartment] = useState('all');
  const [filterTeam, setFilterTeam] = useState('all');
  const [filterMyProjects, setFilterMyProjects] = useState('my'); // ברירת מחדל: הפרויקטים שלי
  const [newProjectTask, setNewProjectTask] = useState('');

  // קריאת פרמטרים מה-URL והגדרת פילטרים
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    
    if (params.get('status') === 'active') {
      setFilterStatus('in_progress');
    } else if (params.get('status') === 'completed') {
      setFilterStatus('completed');
    }
  }, [location.search]);
  
  

  // Helper function to check if project should be hidden from current user
  const shouldHideProject = (project) => {
    const hidePersonalProject = project.scope === 'personal' && project.assigneeId !== currentUser.id && project.createdBy !== currentUser.id;
    return hidePersonalProject;
  };

  // Get single project if ID is provided
  const selectedProject = id ? projects.find(p => p.id === id) : null;

  // Project status calculation - תמיד מחזיר באנגלית
// Project status calculation - תמיד מחזיר באנגלית
function getProjectStatus(project) {
  // אם יש סטטוס ישיר, תמיד החזר באנגלית
  if (project.status) {
    // המרה מעברית לאנגלית אם צריך
    if (project.status === 'ממתין לעבודה') return 'pending';
    if (project.status === 'פרויקט בתהליך') return 'in_progress';
    if (project.status === 'פרויקט הושלם') return 'completed';
    // אם כבר באנגלית
    if (project.status === 'pending' || project.status === 'in_progress' || project.status === 'completed') {
      return project.status;
    }
  }
  
  const projectTasks = tasks.filter(t => t.projectId === project.id);
  
  if (projectTasks.length === 0) {
    return 'pending';
  }
  
  const completedTasks = projectTasks.filter(t => t.status === 'הושלם').length;
  const activeTasks = projectTasks.filter(t => t.status !== 'הושלם');
  
  if (completedTasks === projectTasks.length) {
    return 'completed';
  }
  
  if (activeTasks.length > 0) {
    return 'in_progress';
  }
  
  return 'pending';
}    
   const ProjectTasks = ({ project, tasks }) => {
  const navigate = useNavigate();
  const [showNewTaskModal, setShowNewTaskModal] = useState(false);
  const [newTaskSubtask, setNewTaskSubtask] = useState('');
  const { createTask } = useData();
  const { currentUser } = useAuth();
  const { teams, departments } = useData();
  
  const [newTask, setNewTask] = useState({
    title: '',
    description: '',
    assigneeId: currentUser?.id || '',
    assigneeIds: [currentUser?.id || ''],
    teamMembers: [],
    priority: 'important_not_urgent',
    dueDate: '',
    dueTime: '09:00', // שעת יעד ברירת מחדל
    estimate: 0,
    status: 'ממתין לעבודה',
    projectId: project.id,
    departmentId: project.departmentId || '',
    teamId: project.teamId || '',
    scope: project.scope || 'personal',
    subtasks: []
  });

  const handleCreateTask = async (e) => {
    e.preventDefault();
    try {
      const taskData = {
        ...newTask,
        createdBy: currentUser.id,
        creatorId: currentUser.id,
        projectId: project.id,
        scope: project.scope,
        departmentId: project.departmentId || '',
        teamId: project.teamId || ''
      };
      
      await createTask(taskData);
      
      // Reset form
      setNewTask({
        title: '',
        description: '',
        assigneeId: currentUser?.id || '',
        assigneeIds: [currentUser?.id || ''],
        teamMembers: [],
        priority: 'important_not_urgent',
        dueDate: '',
        estimate: 0,
        status: 'ממתין לעבודה',
        projectId: project.id,
        departmentId: project.departmentId || '',
        teamId: project.teamId || '',
        scope: project.scope || 'personal',
        subtasks: []
      });
      setNewTaskSubtask('');
      setShowNewTaskModal(false);
    } catch (error) {
      console.error('Error creating task:', error);
      alert('שגיאה ביצירת המשימה');
    }
  };

  const handleKeyDown = (e) => {
    // אם לוחצים Enter ב-textarea, לא לשלוח את הטופס
    if (e.key === 'Enter' && e.target.tagName === 'TEXTAREA') {
      e.stopPropagation();
    }
  };

  return (
    <div>
      {/* Header with Add Task Button */}
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-semibold">משימות הפרויקט</h3>
        <button
          onClick={() => setShowNewTaskModal(true)}
          className="flex items-center gap-2 px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700"
        >
          <Plus size={20} />
          משימה חדשה
        </button>
      </div>

      {/* Tasks List */}
      {tasks.length === 0 ? (
        <div className="text-center py-8">
          <p className="text-gray-500">אין משימות בפרויקט זה</p>
        </div>
      ) : (
        <div className="space-y-3">
          {tasks.map(task => (
            <div 
              key={task.id} 
              className="bg-white p-4 rounded-lg border hover:shadow-md transition-shadow cursor-pointer"
              onClick={() => navigate(`/tasks/${task.id}`)}
            >
              <div className="flex items-center justify-between">
                <div className="flex-1">
                  <h4 className="font-medium">{task.title}</h4>
                  {task.description && (
                    <p className="text-sm text-gray-600 mt-1">{task.description}</p>
                  )}
                </div>
                <StatusBadge status={task.status} size="sm" />
              </div>
            </div>
          ))}
        </div>
      )}

      {/* New Task Modal */}
      {showNewTaskModal && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm flex items-center justify-center z-50 p-4"
          onClick={() => setShowNewTaskModal(false)}
        >
          <div 
            className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto border border-gray-100"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div className="bg-gradient-to-r from-purple-600 to-purple-700 text-white p-6 rounded-t-2xl">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-white bg-opacity-20 rounded-full flex items-center justify-center">
                    <Plus size={24} />
                  </div>
                  <div>
                    <h2 className="text-2xl font-bold">משימה חדשה</h2>
                    <p className="text-purple-100 text-sm">צור משימה חדשה ב{project.name}</p>
                  </div>
                </div>
                <button
                  onClick={() => setShowNewTaskModal(false)}
                  className="w-8 h-8 bg-white bg-opacity-20 rounded-full flex items-center justify-center hover:bg-white hover:bg-opacity-30 transition-all"
                >
                  <X size={20} />
                </button>
              </div>
            </div>

            {/* Form Content */}
            <div className="p-6">
              <form onSubmit={handleCreateTask}>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {/* Left Column */}
                  <div className="space-y-4">
                    {/* Title */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                        <FileText size={16} className="text-purple-600" />
                        כותרת המשימה
                      </label>
                      <input
                        type="text"
                        value={newTask.title}
                        onChange={(e) => setNewTask({...newTask, title: e.target.value})}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all"
                        placeholder="הכנס כותרת למשימה..."
                        required
                      />
                    </div>
                    
                    {/* Description */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                        <FileText size={16} className="text-purple-600" />
                        תיאור המשימה
                      </label>
                      <textarea
                        value={newTask.description}
                        onChange={(e) => setNewTask({...newTask, description: e.target.value})}
                        onKeyDown={handleKeyDown}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all h-24 resize-none"
                        placeholder="תאר את המשימה בפירוט..."
                        rows="3"
                      />
                    </div>

                    {/* Priority */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                        <AlertTriangle size={16} className="text-purple-600" />
                        עדיפות
                      </label>
                      <select
                        value={newTask.priority}
                        onChange={(e) => setNewTask({...newTask, priority: e.target.value})}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all"
                      >
                        <option value="important_urgent">🔥 חשוב ודחוף</option>
                        <option value="important_not_urgent">⭐ חשוב ולא דחוף</option>
                        <option value="not_important_urgent">⚡ לא חשוב ודחוף</option>
                        <option value="not_important_not_urgent">📝 לא חשוב ולא דחוף</option>
                      </select>
                    </div>
                  </div>

                  {/* Right Column */}
                  <div className="space-y-4">
                    {/* Due Date */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                        <Calendar size={16} className="text-purple-600" />
                        תאריך יעד
                      </label>
                      <input
                        type="date"
                        value={newTask.dueDate}
                        onChange={(e) => setNewTask({...newTask, dueDate: e.target.value})}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all"
                      />
                    </div>

                    {/* Due Time */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                        <Clock size={16} className="text-purple-600" />
                        שעת יעד
                      </label>
                      <input
                        type="time"
                        value={newTask.dueTime}
                        onChange={(e) => setNewTask({...newTask, dueTime: e.target.value})}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all"
                      />
                    </div>

                    {/* Estimate */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                        <Clock size={16} className="text-purple-600" />
                        הערכת זמן
                      </label>
                      <input
                        type="number"
                        value={newTask.estimate}
                        onChange={(e) => setNewTask({...newTask, estimate: parseInt(e.target.value) || 0})}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all"
                        min="0"
                        placeholder="שעות"
                      />
                    </div>

                    {/* Assignees - Multiple Selection */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                        <Users size={16} className="text-purple-600" />
                        אחראים על המשימה
                        <span className="text-xs text-gray-500">(ניתן לבחור מספר)</span>
                      </label>
                      <div className="border border-gray-300 rounded-lg p-3 max-h-48 overflow-y-auto bg-white">
                        {/* Current User */}
                        <label className="flex items-center gap-3 p-2 hover:bg-purple-50 rounded-lg cursor-pointer transition-all">
                          <input
                            type="checkbox"
                            checked={newTask.assigneeIds?.includes(currentUser?.id)}
                            onChange={(e) => {
                              const currentIds = newTask.assigneeIds || [];
                              let updatedIds;
                              if (e.target.checked) {
                                updatedIds = [...currentIds, currentUser?.id];
                              } else {
                                updatedIds = currentIds.filter(id => id !== currentUser?.id);
                              }
                              setNewTask({
                                ...newTask,
                                assigneeIds: updatedIds,
                                assigneeId: updatedIds[0] || currentUser?.id
                              });
                            }}
                            className="w-4 h-4 text-purple-600 border-gray-300 rounded focus:ring-purple-500"
                          />
                          <div className="flex items-center gap-2">
                            <div className="w-8 h-8 rounded-full bg-gradient-to-br from-purple-500 to-pink-500 flex items-center justify-center text-white font-bold text-xs">
                              {(currentUser?.name || 'אני').charAt(0).toUpperCase()}
                            </div>
                            <span className="font-medium text-gray-900">{currentUser?.name || 'אני'}</span>
                          </div>
                        </label>

                        {/* Team Members */}
                        {project.teamMembers && project.teamMembers
                          .filter(memberId => memberId !== currentUser?.id)
                          .map(memberId => {
                            const user = users.find(u => u.id === memberId);
                            if (!user) return null;
                            
                            return (
                              <label key={user.id} className="flex items-center gap-3 p-2 hover:bg-purple-50 rounded-lg cursor-pointer transition-all">
                                <input
                                  type="checkbox"
                                  checked={newTask.assigneeIds?.includes(user.id)}
                                  onChange={(e) => {
                                    const currentIds = newTask.assigneeIds || [];
                                    let updatedIds;
                                    if (e.target.checked) {
                                      updatedIds = [...currentIds, user.id];
                                    } else {
                                      updatedIds = currentIds.filter(id => id !== user.id);
                                    }
                                    setNewTask({
                                      ...newTask,
                                      assigneeIds: updatedIds,
                                      assigneeId: updatedIds[0] || currentUser?.id
                                    });
                                  }}
                                  className="w-4 h-4 text-purple-600 border-gray-300 rounded focus:ring-purple-500"
                                />
                                <div className="flex items-center gap-2">
                                  <div className="w-8 h-8 rounded-full bg-gradient-to-br from-blue-500 to-cyan-500 flex items-center justify-center text-white font-bold text-xs">
                                    {user.name.charAt(0).toUpperCase()}
                                  </div>
                                  <span className="font-medium text-gray-900">{user.name}</span>
                                </div>
                              </label>
                            );
                          })}
                      </div>
                      {newTask.assigneeIds && newTask.assigneeIds.length > 0 && (
                        <div className="mt-2 text-sm text-purple-600 font-medium">
                          ✓ נבחרו {newTask.assigneeIds.length} אחראי{newTask.assigneeIds.length > 1 ? 'ם' : ''}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Subtasks - Full Width */}
                  <div className="col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                      <List size={16} className="text-purple-600" />
                      תתי משימות
                    </label>
                    <div className="space-y-2">
                      {newTask.subtasks && newTask.subtasks.length > 0 && (
                        <div className="space-y-2">
                          {newTask.subtasks.map((subtask, index) => (
                            <div key={index} className="flex items-center gap-2">
                              <div className="flex-1 px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg text-sm">
                                {subtask}
                              </div>
                              <button
                                type="button"
                                onClick={() => {
                                  const updatedSubtasks = newTask.subtasks.filter((_, i) => i !== index);
                                  setNewTask({...newTask, subtasks: updatedSubtasks});
                                }}
                                className="w-8 h-8 bg-red-100 hover:bg-red-200 text-red-600 rounded-lg flex items-center justify-center transition-all"
                              >
                                <X size={16} />
                              </button>
                            </div>
                          ))}
                        </div>
                      )}
                      <div className="flex gap-2">
                        <input
                          type="text"
                          value={newTaskSubtask || ''}
                          onChange={(e) => setNewTaskSubtask(e.target.value)}
                          onKeyPress={(e) => {
                            if (e.key === 'Enter' && newTaskSubtask.trim()) {
                              e.preventDefault();
                              const updatedSubtasks = [...(newTask.subtasks || []), newTaskSubtask.trim()];
                              setNewTask({...newTask, subtasks: updatedSubtasks});
                              setNewTaskSubtask('');
                            }
                          }}
                          className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all"
                          placeholder="הוסף תת משימה חדשה..."
                        />
                        <button
                          type="button"
                          onClick={() => {
                            if (newTaskSubtask && newTaskSubtask.trim()) {
                              const updatedSubtasks = [...(newTask.subtasks || []), newTaskSubtask.trim()];
                              setNewTask({...newTask, subtasks: updatedSubtasks});
                              setNewTaskSubtask('');
                            }
                          }}
                          className="px-4 py-2 bg-purple-100 hover:bg-purple-200 text-purple-700 rounded-lg flex items-center gap-2 transition-all font-medium"
                        >
                          <Plus size={16} />
                          הוסף
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                
                {/* Action Buttons */}
                <div className="mt-8 flex gap-3 justify-end pt-6 border-t border-gray-100">
                  <button
                    type="button"
                    onClick={() => setShowNewTaskModal(false)}
                    className="px-6 py-3 text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-xl transition-all font-medium"
                  >
                    ביטול
                  </button>
                  <button
                    type="submit"
                    className="px-8 py-3 bg-gradient-to-r from-purple-600 to-purple-700 text-white rounded-xl hover:from-purple-700 hover:to-purple-800 transition-all font-semibold shadow-lg hover:shadow-xl transform hover:scale-105"
                  >
                    <div className="flex items-center gap-2">
                      <Plus size={20} />
                      צור משימה
                    </div>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
  // Filter projects based on search and filters
  const filteredProjects = projects.filter(project => {
    // First filter by user role and access
    let hasAccess = false;
    
    if (currentUser?.role === 'org_admin' || currentUser?.role === 'ceo' || currentUser?.role === 'deputy_ceo') {
      if (mainTab === 'management') {
        // מנהלים עליונים רואים כל הפרויקטים הארגוניים כולל פרויקטי צוותים
        hasAccess = (project.scope === 'managerial' || project.scope === 'department' || 
                    (project.scope === 'managerial' && project.teamId));
      } else {
        hasAccess = (project.scope === 'personal' && 
                    (project.createdBy === currentUser.id || project.assigneeId === currentUser.id));
      }
    } else if (currentUser?.role === 'dept_manager') {
      if (mainTab === 'management') {
        // מנהל מחלקה רואה גם פרויקטים של צוותים במחלקה שלו
        hasAccess = project.departmentId === currentUser.departmentId ||
                   (project.teamId && teams.some(team => team.id === project.teamId && team.departmentId === currentUser.departmentId));
      } else {
        hasAccess = (project.scope === 'personal' && 
                    (project.createdBy === currentUser.id || project.assigneeId === currentUser.id));
      }
    } else if (currentUser?.role === 'team_manager') {
      if (mainTab === 'team') {
        const userTeam = teams.find(team => team.managerId === currentUser.id);
        hasAccess = userTeam && (
          project.teamId === userTeam.id ||
          (project.scope === 'managerial' && project.teamId === userTeam.id)
        );
      } else {
        hasAccess = (project.scope === 'personal' && 
                    (project.createdBy === currentUser.id || project.assigneeId === currentUser.id));
      }
    } else if (currentUser?.role === 'employee') {
      if (mainTab === 'management') {
        hasAccess = (project.scope === 'managerial' && 
                    (project.assigneeId === currentUser.id ||
                     (Array.isArray(project.teamMembers) && project.teamMembers.includes(currentUser.id))));
      } else {
        hasAccess = (project.scope === 'personal' && 
                    (project.createdBy === currentUser.id || project.assigneeId === currentUser.id));
      }
    }
    
    if (!hasAccess) return false;
    
    if (shouldHideProject(project)) return false;
    
    // Apply search filter
    const matchesSearch = project.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         project.description?.toLowerCase().includes(searchTerm.toLowerCase());
    
    // Apply scope filter
    const matchesScope = filterScope === 'all' || project.scope === filterScope;
    
    // Apply status filter - משווה לערכים באנגלית
    const projectStatus = getProjectStatus(project);
    const matchesStatus = filterStatus === 'all' || projectStatus === filterStatus;
    
    // Apply priority filter
    const matchesPriority = filterPriority === 'all' || project.priority === filterPriority;
    // Apply department filter - חדש
    const matchesDepartment = filterDepartment === 'all' || project.departmentId === filterDepartment;
    
    // Apply team filter - חדש למנכל וסמנכל
    const matchesTeam = filterTeam === 'all' || project.teamId === filterTeam;
    
    // Apply "My Projects" filter - רק פרויקטים שאני משויך אליהם
    const matchesMyProjects = filterMyProjects === 'all' || 
      (Array.isArray(project.teamMembers) && project.teamMembers.includes(currentUser?.id));
    
    return matchesSearch && matchesScope && matchesStatus && matchesPriority && matchesDepartment && matchesTeam && matchesMyProjects;
  });

  // New project form
  const [newProject, setNewProject] = useState({
    name: '',
    description: '',
    scope: currentUser?.role === 'employee' ? 'personal' : 'managerial',
    priority: 'important_not_urgent',
    departmentId: '',
    teamId: '',
    startDate: '',
    endDate: '',
    teamMembers: currentUser?.role === 'employee' ? [currentUser.id] : [],
    assigneeId: '',
    projectTasks: [],
    assignedUsers: []
  });

  const handleCreateProject = async (e) => {
    e.preventDefault();
    try {
      const projectId = await createProject(newProject);
      setShowNewProject(false);
      setNewProject({
        name: '',
        description: '',
        scope: currentUser?.role === 'employee' ? 'personal' : 'managerial',
        priority: 'important_not_urgent',
        departmentId: '',
        teamId: '',
        startDate: '',
        endDate: '',
        teamMembers: currentUser?.role === 'employee' ? [currentUser.id] : [],
        assigneeId: '',
        projectTasks: [],
        assignedUsers: []
      });
      setNewProjectTask('');
      navigate(`/projects/${projectId}`);
    } catch (error) {
      console.error('Error creating project:', error);
    }
  };

  // Edit project function
// Edit project function
const handleEditProject = (project) => {
  requestAnimationFrame(() => {
    setEditProject({...project});
    setShowEditProject(true);
  });
};

// Change project status function
const handleChangeStatus = (project) => {
  requestAnimationFrame(() => {
    setStatusProject({...project});
    setShowStatusModal(true);
  });
};

  // Check if user can delete project
  const canDeleteProject = (project) => {
    // מנכ"ל, סמנכ"ל ומנהל ארגון - כל הפרויקטים
    if (currentUser?.role === 'ceo' || currentUser?.role === 'deputy_ceo' || currentUser?.role === 'org_admin') {
      return true;
    }
    
    // מנהל מחלקה - פרויקטים של המחלקה שלו
    if (currentUser?.role === 'dept_manager') {
      return project.departmentId === currentUser.departmentId;
    }
    
    // מנהל צוות - פרויקטים של הצוות שלו
    if (currentUser?.role === 'team_manager') {
      return project.teamId === currentUser.teamId;
    }
    
    // עובד - רק פרויקטים אישיים שלו
    if (currentUser?.role === 'employee') {
      return project.scope === 'personal' && project.createdBy === currentUser.id;
    }
    
    return false;
  };

  // Delete project function
  const handleDeleteProject = async (project) => {
    if (window.confirm(`האם אתה בטוח שברצונך למחוק את הפרויקט "${project.name}"?`)) {
      try {
        await deleteDoc(doc(db, COLLECTIONS.PROJECTS, project.id));
        navigate('/projects');
      } catch (error) {
        console.error('Error deleting project:', error);
        alert('שגיאה במחיקת הפרויקט');
      }
    }
  };

  // If showing project details
  if (selectedProject) {
    const projectTasks = tasks.filter(t => t.projectId === selectedProject.id);
    const projectStatus = getProjectStatus(selectedProject);
    const completedTasks = projectTasks.filter(t => t.status === 'הושלם').length;
    const totalTasks = projectTasks.length;
    const progress = totalTasks > 0 ? (completedTasks / totalTasks) * 100 : 0;

    const teamMembers = selectedProject.teamMembers?.map(memberId => 
      users.find(u => u.id === memberId)
    ).filter(member => member && member.name) || [];

    // Tabs for project details
    const projectTabs = [
      {
        id: 'overview',
        label: 'סקירה כללית',
        icon: Info,
        content: <ProjectOverview project={selectedProject} tasks={projectTasks} teamMembers={teamMembers} departments={departments} />
      },
      {
        id: 'tasks',
        label: 'משימות',
        icon: CheckSquare,
        badge: totalTasks.toString(),
        content: <ProjectTasks project={selectedProject} tasks={projectTasks} />
      },
      {
        id: 'team',
        label: 'צוות',
        icon: Users,
        badge: teamMembers.length.toString(),
        content: <ProjectTeam project={selectedProject} teamMembers={teamMembers} tasks={projectTasks} departments={departments} />
      },
      {
        id: 'activity',
        label: 'פעילות',
        icon: Activity,
        content: <ProjectActivity project={selectedProject} />
      }
    ];

    return (
      <div className="p-6">
      {/* Project Header - עיצוב מחודש */}
<div className="mb-8">
  <button
    onClick={() => navigate('/projects')}
    className="flex items-center gap-2 text-gray-600 hover:text-blue-600 mb-6 transition-colors group"
  >
    <div className="w-8 h-8 bg-gray-100 group-hover:bg-blue-100 rounded-lg flex items-center justify-center transition-colors">
      <ChevronRight size={20} />
    </div>
    <span className="font-medium">חזרה לפרויקטים</span>
  </button>
  
  <div className="bg-gradient-to-br from-white to-gray-50 rounded-3xl shadow-xl border border-gray-100 overflow-hidden">
    {/* גרדיאנט עליון */}
    <div className={`h-3 bg-gradient-to-r ${(() => {
      switch(projectStatus) {
        case 'pending': return 'from-gray-500 to-gray-600';
        case 'in_progress': return 'from-blue-500 to-indigo-600';
        case 'completed': return 'from-green-500 to-emerald-600';
        default: return 'from-gray-500 to-gray-600';
      }
    })()}`}></div>

    <div className="p-8">
      <div className="flex items-start justify-between mb-6">
        <div className="flex-1">
          {/* אייקון ושם הפרויקט */}
          <div className="flex items-center gap-4 mb-4">
            <div className={`w-20 h-20 rounded-2xl bg-gradient-to-br ${(() => {
              switch(projectStatus) {
                case 'pending': return 'from-gray-500 to-gray-600';
                case 'in_progress': return 'from-blue-500 to-indigo-600';
                case 'completed': return 'from-green-500 to-emerald-600';
                default: return 'from-gray-500 to-gray-600';
              }
            })()} flex items-center justify-center shadow-lg`}>
              <FolderOpen className="w-10 h-10 text-white" />
            </div>
            <div className="flex-1">
              <h1 className="text-3xl font-bold text-gray-800 mb-2">{selectedProject.name}</h1>
              <p className="text-xl md:text-2xl font-bold bg-gradient-to-r from-gray-800 to-blue-800 bg-clip-text text-transparent leading-relaxed mt-3 border-r-4 border-blue-500 pr-4 py-2 bg-blue-50/50 rounded-lg">
  {selectedProject.description}
</p>
            </div>
          </div>
          
          {/* תגיות מחלקה וצוות */}
          <div className="flex flex-wrap gap-3">
            {selectedProject.departmentId ? (
              <span className="px-4 py-2 bg-gradient-to-r from-blue-50 to-indigo-50 text-blue-700 rounded-xl flex items-center gap-2 font-medium border border-blue-200 shadow-sm">
                <Building2 size={18} />
                {departments.find(d => d.id === selectedProject.departmentId)?.name || 'לא ידוע'}
              </span>
            ) : (
              <span className="px-4 py-2 bg-gray-100 text-gray-600 rounded-xl flex items-center gap-2 font-medium">
                <Building2 size={18} />
                ללא מחלקה
              </span>
            )}
            
            {selectedProject.teamId ? (
              <span className="px-4 py-2 bg-gradient-to-r from-purple-50 to-pink-50 text-purple-700 rounded-xl flex items-center gap-2 font-medium border border-purple-200 shadow-sm">
                <Users size={18} />
                {teams.find(t => t.id === selectedProject.teamId)?.name || 'לא ידוע'}
              </span>
            ) : (
              <span className="px-4 py-2 bg-gray-100 text-gray-600 rounded-xl flex items-center gap-2 font-medium">
                <Users size={18} />
                ללא צוות
              </span>
            )}
          </div>
        </div>
        
        {/* סטטוס בדג' גדול */}
        <div className={`px-6 py-3 rounded-2xl text-lg font-bold shadow-lg ${(() => {
          switch(projectStatus) {
            case 'pending': return 'bg-gray-100 text-gray-700 border-2 border-gray-300';
            case 'in_progress': return 'bg-blue-100 text-blue-700 border-2 border-blue-300';
            case 'completed': return 'bg-green-100 text-green-700 border-2 border-green-300';
            default: return 'bg-gray-100 text-gray-700';
          }
        })()}`}>
          {(() => {
            switch(projectStatus) {
              case 'pending': return '⏳ ממתין לעבודה';
              case 'in_progress': return '🚀 פרויקט בתהליך';
              case 'completed': return '✅ פרויקט הושלם';
              default: return projectStatus;
            }
          })()}
        </div>
      </div>

      {/* פס התקדמות גדול */}
      <div className="mt-8 bg-white rounded-2xl p-6 shadow-inner border border-gray-100">
        <div className="flex justify-between items-center mb-3">
          <span className="text-lg font-semibold text-gray-700">התקדמות כללית</span>
          <span className="text-2xl font-bold text-gray-800">{completedTasks} / {totalTasks}</span>
        </div>
        <div className="w-full bg-gray-200 rounded-full h-6 overflow-hidden shadow-inner mb-3">
          <div 
            className={`h-6 rounded-full bg-gradient-to-r ${(() => {
              switch(projectStatus) {
                case 'pending': return 'from-gray-500 to-gray-600';
                case 'in_progress': return 'from-blue-500 to-indigo-600';
                case 'completed': return 'from-green-500 to-emerald-600';
                default: return 'from-gray-500 to-gray-600';
              }
            })()} transition-all duration-500 shadow-lg flex items-center justify-end px-3`}
            style={{ width: `${progress}%` }}
          >
            <span className="text-white font-bold text-sm">{progress.toFixed(0)}%</span>
          </div>
        </div>
        
        {projectStatus === 'completed' && (
          <div className="mt-4 p-4 bg-gradient-to-r from-green-50 to-emerald-50 border-2 border-green-200 rounded-xl">
            <div className="flex items-center gap-3 text-green-700">
              <div className="w-10 h-10 bg-green-200 rounded-full flex items-center justify-center">
                <CheckCircle size={20} />
              </div>
              <div>
                <span className="font-bold text-lg">פרויקט הושלם בהצלחה! 🎉</span>
                {selectedProject.updatedAt && (
                  <p className="text-sm text-green-600 mt-1">
                    הושלם ב-{new Date(selectedProject.updatedAt).toLocaleDateString('he-IL')}
                  </p>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  </div>
</div>

        {/* Tabs */}
        <TabsComponent 
          tabs={projectTabs}
          activeTab={activeTab}
          onTabChange={setActiveTab}
        />



        </div>
    );
  }

  // Projects list view
  return (
    <div className="p-4 md:p-6 pb-6 md:pb-8">
      <div className="mb-6">
        <div className="flex flex-col sm:flex-row gap-4 sm:justify-between sm:items-center">
          <h1 className="text-xl md:text-2xl font-bold">פרויקטים</h1>
          <div className="flex gap-2">
            <button
              onClick={() => setShowNewProject(true)}
              className="flex items-center justify-center gap-2 px-4 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 min-h-[44px] touch-manipulation"
            >
              <Plus size={20} />
              פרויקט חדש
            </button>
          </div>
        </div>
      </div>

   {/* Main Tabs for Managers and Admins - עיצוב מחודש */}
{(currentUser?.role === 'org_admin' || currentUser?.role === 'ceo' || currentUser?.role === 'deputy_ceo') && (
  <div className="bg-gradient-to-br from-white to-gray-50 rounded-2xl shadow-xl border-2 border-gray-200 mb-6 overflow-hidden">
    <div className="bg-gradient-to-r from-blue-600 to-purple-600 px-6 py-2">
      <div className="h-1 bg-white opacity-30 rounded-full"></div>
    </div>
    <div className="border-b border-gray-200">
      <nav className="flex flex-wrap gap-2 px-6">
        <button
          onClick={() => setMainTab('management')}
          className={`relative py-4 px-6 font-semibold text-sm transition-all duration-300 ${
            mainTab === 'management'
              ? 'text-blue-600'
              : 'text-gray-500 hover:text-gray-700'
          }`}
        >
          <div className="flex items-center gap-2">
            <div className={`w-10 h-10 rounded-xl flex items-center justify-center transition-all duration-300 ${
              mainTab === 'management' 
                ? 'bg-gradient-to-br from-blue-500 to-purple-600 text-white shadow-lg' 
                : 'bg-gray-100 text-gray-500'
            }`}>
              <Building2 size={20} />
            </div>
            <span>ארגוני</span>
          </div>
          {mainTab === 'management' && (
            <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-blue-500 to-purple-600 rounded-t-full"></div>
          )}
        </button>
        <button
          onClick={() => setMainTab('personal')}
          className={`relative py-4 px-6 font-semibold text-sm transition-all duration-300 ${
            mainTab === 'personal'
              ? 'text-blue-600'
              : 'text-gray-500 hover:text-gray-700'
          }`}
        >
          <div className="flex items-center gap-2">
            <div className={`w-10 h-10 rounded-xl flex items-center justify-center transition-all duration-300 ${
              mainTab === 'personal' 
                ? 'bg-gradient-to-br from-blue-500 to-purple-600 text-white shadow-lg' 
                : 'bg-gray-100 text-gray-500'
            }`}>
              <User size={20} />
            </div>
            <span>אישי</span>
          </div>
          {mainTab === 'personal' && (
            <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-blue-500 to-purple-600 rounded-t-full"></div>
          )}
        </button>
      </nav>
    </div>
    <div className="p-4 bg-gradient-to-r from-blue-50 to-purple-50">
      <div className="text-sm font-medium text-gray-700 flex items-center gap-2">
        <div className="w-2 h-2 bg-blue-500 rounded-full animate-pulse"></div>
        {mainTab === 'management' ? (
          <span>צפייה בכל הפרויקטים הארגוניים של החברה</span>
        ) : (
          <span>צפייה בפרויקטים האישיים שלך</span>
        )}
      </div>
    </div>
  </div>
)}

{/* Team Manager Tabs - עיצוב מחודש */}
{currentUser?.role === 'team_manager' && (
  <div className="bg-gradient-to-br from-white to-gray-50 rounded-2xl shadow-xl border-2 border-gray-200 mb-6 overflow-hidden">
    <div className="bg-gradient-to-r from-purple-600 to-pink-600 px-6 py-2">
      <div className="h-1 bg-white opacity-30 rounded-full"></div>
    </div>
    <div className="border-b border-gray-200">
      <nav className="flex flex-wrap gap-2 px-6">
        <button
          onClick={() => setMainTab('team')}
          className={`relative py-4 px-6 font-semibold text-sm transition-all duration-300 ${
            mainTab === 'team'
              ? 'text-purple-600'
              : 'text-gray-500 hover:text-gray-700'
          }`}
        >
          <div className="flex items-center gap-2">
            <div className={`w-10 h-10 rounded-xl flex items-center justify-center transition-all duration-300 ${
              mainTab === 'team' 
                ? 'bg-gradient-to-br from-purple-500 to-pink-600 text-white shadow-lg' 
                : 'bg-gray-100 text-gray-500'
            }`}>
              <Users size={20} />
            </div>
            <span>צוותי</span>
          </div>
          {mainTab === 'team' && (
            <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-purple-500 to-pink-600 rounded-t-full"></div>
          )}
        </button>
        <button
          onClick={() => setMainTab('personal')}
          className={`relative py-4 px-6 font-semibold text-sm transition-all duration-300 ${
            mainTab === 'personal'
              ? 'text-purple-600'
              : 'text-gray-500 hover:text-gray-700'
          }`}
        >
          <div className="flex items-center gap-2">
            <div className={`w-10 h-10 rounded-xl flex items-center justify-center transition-all duration-300 ${
              mainTab === 'personal' 
                ? 'bg-gradient-to-br from-purple-500 to-pink-600 text-white shadow-lg' 
                : 'bg-gray-100 text-gray-500'
            }`}>
              <User size={20} />
            </div>
            <span>אישי</span>
          </div>
          {mainTab === 'personal' && (
            <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-purple-500 to-pink-600 rounded-t-full"></div>
          )}
        </button>
      </nav>
    </div>
    <div className="p-4 bg-gradient-to-r from-purple-50 to-pink-50">
      <div className="text-sm font-medium text-gray-700 flex items-center gap-2">
        <div className="w-2 h-2 bg-purple-500 rounded-full animate-pulse"></div>
        {mainTab === 'team' ? (
          <span>צפייה בפרויקטים של הצוות שלך</span>
        ) : (
          <span>צפייה בפרויקטים האישיים שלך</span>
        )}
      </div>
    </div>
  </div>
)}

{/* Department Manager and Employee Tabs - עיצוב מחודש */}
{(currentUser?.role === 'dept_manager' || currentUser?.role === 'employee') && (
  <div className="bg-gradient-to-br from-white to-gray-50 rounded-2xl shadow-xl border-2 border-gray-200 mb-6 overflow-hidden">
    <div className="bg-gradient-to-r from-indigo-600 to-blue-600 px-6 py-2">
      <div className="h-1 bg-white opacity-30 rounded-full"></div>
    </div>
    <div className="border-b border-gray-200">
      <nav className="flex flex-wrap gap-2 px-6">
        <button
          onClick={() => setMainTab('management')}
          className={`relative py-4 px-6 font-semibold text-sm transition-all duration-300 ${
            mainTab === 'management'
              ? 'text-indigo-600'
              : 'text-gray-500 hover:text-gray-700'
          }`}
        >
          <div className="flex items-center gap-2">
            <div className={`w-10 h-10 rounded-xl flex items-center justify-center transition-all duration-300 ${
              mainTab === 'management' 
                ? 'bg-gradient-to-br from-indigo-500 to-blue-600 text-white shadow-lg' 
                : 'bg-gray-100 text-gray-500'
            }`}>
              <Building2 size={20} />
            </div>
            <span>ארגוני</span>
          </div>
          {mainTab === 'management' && (
            <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-indigo-500 to-blue-600 rounded-t-full"></div>
          )}
        </button>
        <button
          onClick={() => setMainTab('personal')}
          className={`relative py-4 px-6 font-semibold text-sm transition-all duration-300 ${
            mainTab === 'personal'
              ? 'text-indigo-600'
              : 'text-gray-500 hover:text-gray-700'
          }`}
        >
          <div className="flex items-center gap-2">
            <div className={`w-10 h-10 rounded-xl flex items-center justify-center transition-all duration-300 ${
              mainTab === 'personal' 
                ? 'bg-gradient-to-br from-indigo-500 to-blue-600 text-white shadow-lg' 
                : 'bg-gray-100 text-gray-500'
            }`}>
              <User size={20} />
            </div>
            <span>אישי</span>
          </div>
          {mainTab === 'personal' && (
            <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-indigo-500 to-blue-600 rounded-t-full"></div>
          )}
        </button>
      </nav>
    </div>
    <div className="p-4 bg-gradient-to-r from-indigo-50 to-blue-50">
      <div className="text-sm font-medium text-gray-700 flex items-center gap-2">
        <div className="w-2 h-2 bg-indigo-500 rounded-full animate-pulse"></div>
        {mainTab === 'management' ? (
          currentUser?.role === 'dept_manager' ? (
            <span>צפייה בפרויקטים של המחלקה שלך</span>
          ) : (
            <span>צפייה בפרויקטים הארגוניים שלך</span>
          )
        ) : (
          <span>צפייה בפרויקטים האישיים שלך</span>
        )}
      </div>
    </div>
  </div>
)}

      {/* Team Manager Tabs */}
      {currentUser?.role === 'team_manager' && (
        <div className="bg-white rounded-lg shadow mb-6">
          <div className="border-b">
            <nav className="flex flex-wrap gap-2 sm:space-x-8 px-4 sm:px-6">
              <button
                onClick={() => setMainTab('team')}
                className={`py-4 px-1 border-b-2 font-medium text-sm ${
                  mainTab === 'team'
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                <div className="flex items-center gap-2">
                  <Users size={20} />
                  צוותי
                </div>
              </button>
              <button
                onClick={() => setMainTab('personal')}
                className={`py-4 px-1 border-b-2 font-medium text-sm ${
                  mainTab === 'personal'
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                <div className="flex items-center gap-2">
                  <User size={20} />
                  אישי
                </div>
              </button>
            </nav>
          </div>
          <div className="p-4">
            <div className="text-sm text-gray-600">
              {mainTab === 'team' ? (
                <span>צפייה בפרויקטים של הצוות שלך</span>
              ) : (
                <span>צפייה בפרויקטים האישיים שלך</span>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Department Manager and Employee Tabs */}
      {(currentUser?.role === 'dept_manager' || currentUser?.role === 'employee') && (
        <div className="bg-white rounded-lg shadow mb-6">
          <div className="border-b">
            <nav className="flex flex-wrap gap-2 sm:space-x-8 px-4 sm:px-6">
              <button
                onClick={() => setMainTab('management')}
                className={`py-4 px-1 border-b-2 font-medium text-sm ${
                  mainTab === 'management'
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                <div className="flex items-center gap-2">
                  <Building2 size={20} />
                  ארגוני
                </div>
              </button>
              <button
                onClick={() => setMainTab('personal')}
                className={`py-4 px-1 border-b-2 font-medium text-sm ${
                  mainTab === 'personal'
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                <div className="flex items-center gap-2">
                  <User size={20} />
                  אישי
                </div>
              </button>
            </nav>
          </div>
          <div className="p-4">
            <div className="text-sm text-gray-600">
              {mainTab === 'management' ? (
                currentUser?.role === 'dept_manager' ? (
                  <span>צפייה בפרויקטים של המחלקה שלך</span>
                ) : (
                  <span>צפייה בפרויקטים הארגוניים שלך</span>
                )
              ) : (
                <span>צפייה בפרויקטים האישיים שלך</span>
              )}
            </div>
          </div>
        </div>
      )}

{/* Filters - עיצוב מחודש */}
<div className="bg-gradient-to-br from-white to-gray-50 rounded-2xl shadow-xl border-2 border-gray-200 p-6 mb-6">
  <div className="flex items-center gap-2 mb-4">
    <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-purple-600 rounded-xl flex items-center justify-center shadow-lg">
      <Filter className="w-5 h-5 text-white" />
    </div>
    <h3 className="text-lg font-bold text-gray-800">סינון וחיפוש</h3>
  </div>
  
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4">
    {/* Search */}
    <div className="sm:col-span-2 lg:col-span-3 xl:col-span-2">
      <div className="relative">
        <Search className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
        <input
          type="text"
          placeholder="חיפוש פרויקטים..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full pr-10 pl-4 py-3 border-2 border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all min-h-[44px] bg-white shadow-sm hover:shadow-md"
        />
      </div>
    </div>

    {/* My Projects Filter - NEW! */}
    <div className="relative">
      <select 
        value={filterMyProjects}
        onChange={(e) => setFilterMyProjects(e.target.value)}
        className="w-full px-4 py-3 border-2 border-purple-300 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all min-h-[44px] bg-gradient-to-r from-purple-50 to-pink-50 shadow-sm hover:shadow-md appearance-none cursor-pointer font-bold"
      >
        <option value="all">🌐 כל הפרויקטים</option>
        <option value="my">👤 הפרויקטים שלי</option>
      </select>
      <ChevronRight className="absolute left-3 top-1/2 transform -translate-y-1/2 rotate-90 text-purple-400 pointer-events-none" size={20} />
    </div>

    {/* Scope Filter */}
    <div className="relative">
      <select
        value={filterScope}
        onChange={(e) => setFilterScope(e.target.value)}
        className="w-full px-4 py-3 border-2 border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all min-h-[44px] bg-white shadow-sm hover:shadow-md appearance-none cursor-pointer font-medium"
      >
        <option value="all">🌐 כל התחומים</option>
        <option value="personal">👤 אישי</option>
        <option value="managerial">🏢 ניהולי</option>
      </select>
      <ChevronRight className="absolute left-3 top-1/2 transform -translate-y-1/2 rotate-90 text-gray-400 pointer-events-none" size={20} />
    </div>

    {/* Status Filter */}
    <div className="relative">
      <select
        value={filterStatus}
        onChange={(e) => setFilterStatus(e.target.value)}
        className="w-full px-4 py-3 border-2 border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all min-h-[44px] bg-white shadow-sm hover:shadow-md appearance-none cursor-pointer font-medium"
      >
        <option value="all">📊 כל הסטטוסים</option>
        <option value="pending">⏳ ממתין לעבודה</option>
        <option value="in_progress">🚀 פרויקט בתהליך</option>
        <option value="completed">✅ פרויקט הושלם</option>
      </select>
      <ChevronRight className="absolute left-3 top-1/2 transform -translate-y-1/2 rotate-90 text-gray-400 pointer-events-none" size={20} />
    </div>

    {/* Priority Filter */}
    <div className="relative">
      <select
        value={filterPriority}
        onChange={(e) => setFilterPriority(e.target.value)}
        className="w-full px-4 py-3 border-2 border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all min-h-[44px] bg-white shadow-sm hover:shadow-md appearance-none cursor-pointer font-medium"
      >
        <option value="all">⚡ כל העדיפויות</option>
        <option value="important_urgent">🔥 חשוב ודחוף</option>
        <option value="important_not_urgent">⭐ חשוב ולא דחוף</option>
        <option value="not_important_urgent">⚡ לא חשוב ודחוף</option>
        <option value="not_important_not_urgent">📝 לא חשוב ולא דחוף</option>
      </select>
      <ChevronRight className="absolute left-3 top-1/2 transform -translate-y-1/2 rotate-90 text-gray-400 pointer-events-none" size={20} />
    </div>

    {/* Department Filter */}
    <div className="relative">
      <select
        value={filterDepartment}
        onChange={(e) => setFilterDepartment(e.target.value)}
        className="w-full px-4 py-3 border-2 border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all min-h-[44px] bg-white shadow-sm hover:shadow-md appearance-none cursor-pointer font-medium"
      >
        <option value="all">🏢 כל המחלקות</option>
        {departments.map(dept => (
          <option key={dept.id} value={dept.id}>{dept.name}</option>
        ))}
      </select>
      <ChevronRight className="absolute left-3 top-1/2 transform -translate-y-1/2 rotate-90 text-gray-400 pointer-events-none" size={20} />
    </div>

    {/* Team Filter */}
    {(currentUser?.role === 'ceo' || currentUser?.role === 'deputy_ceo' || currentUser?.role === 'org_admin') && (
      <div className="relative">
        <select 
          value={filterTeam}
          onChange={(e) => setFilterTeam(e.target.value)}
          className="w-full px-4 py-3 border-2 border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all min-h-[44px] bg-white shadow-sm hover:shadow-md appearance-none cursor-pointer font-medium"
        >
          <option value="all">👥 כל הצוותים</option>
          {teams.map(team => (
            <option key={team.id} value={team.id}>{team.name}</option>
          ))}
        </select>
        <ChevronRight className="absolute left-3 top-1/2 transform -translate-y-1/2 rotate-90 text-gray-400 pointer-events-none" size={20} />
      </div>
    )}
  </div>
</div>

     {/* Projects Grid - עיצוב מחודש */}
<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
  {filteredProjects.map(project => {
    const projectTasks = tasks.filter(t => t.projectId === project.id);
    const projectStatus = getProjectStatus(project);
    const completedTasks = projectTasks.filter(t => t.status === 'הושלם').length;
    const progress = projectTasks.length > 0 ? (completedTasks / projectTasks.length) * 100 : 0;
    const creatorId = project.creatorId || project.createdBy;
    const creator = users.find(u => u.id === creatorId);

    // צבעים דינמיים לפי סטטוס
    const statusColors = {
      'pending': 'from-gray-500 to-gray-600',
      'in_progress': 'from-blue-500 to-indigo-600',
      'completed': 'from-green-500 to-emerald-600'
    };

    const statusBgColors = {
      'pending': 'bg-gray-50',
      'in_progress': 'bg-blue-50',
      'completed': 'bg-green-50'
    };

    const statusBorderColors = {
      'pending': 'border-gray-200',
      'in_progress': 'border-blue-200',
      'completed': 'border-green-200'
    };

    return (
      <div
        key={project.id}
        className={`group relative bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden border-2 ${statusBorderColors[projectStatus]}`}
      >
        {/* גרדיאנט עליון לפי סטטוס */}
        <div className={`h-2 bg-gradient-to-r ${statusColors[projectStatus]}`}></div>
        
        {/* תוכן הכרטיס */}
        <div 
          className="p-6 cursor-pointer" 
          onClick={(e) => {
            if (!e.target.closest('button') && !e.target.closest('[data-action]')) {
              navigate(`/projects/${project.id}`);
            }
          }}
        >
          {/* כפתורי פעולה */}
          <div 
            className="absolute top-4 left-4 z-20 flex gap-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              data-action="edit"
              onClick={(e) => {
                e.stopPropagation();
                handleEditProject(project);
              }}
              className="flex items-center justify-center p-2.5 bg-white rounded-lg shadow-md hover:shadow-xl text-gray-600 hover:text-blue-600 hover:scale-105 transform transition-all w-10 h-10"
              title="ערוך פרויקט"
            >
              <Edit size={18} />
            </button>
            
            <button
              data-action="status"
              onClick={(e) => {
                e.stopPropagation();
                handleChangeStatus(project);
              }}
              className="flex items-center justify-center p-2.5 bg-white rounded-lg shadow-md hover:shadow-xl text-gray-600 hover:text-purple-600 hover:scale-105 transform transition-all w-10 h-10"
              title="שנה סטטוס"
            >
              <BarChart3 size={18} />
            </button>
            
            {canDeleteProject(project) && (
              <button
                data-action="delete"
                onClick={(e) => {
                  e.stopPropagation();
                  if (window.confirm(`האם אתה בטוח שברצונך למחוק את הפרויקט "${project.name}"?`)) {
                    handleDeleteProject(project);
                  }
                }}
                className="flex items-center justify-center p-2.5 bg-white rounded-lg shadow-md hover:shadow-xl text-gray-600 hover:text-red-600 hover:scale-105 transform transition-all w-10 h-10"
                title="מחק פרויקט"
              >
                <Trash2 size={18} />
              </button>
            )}
          </div>

          {/* סטטוס בדג' - למעלה באמצע */}
          <div className="absolute top-6 left-1/2 transform -translate-x-1/2 z-20">
            <div className={`px-3 py-1.5 rounded-lg ${statusBgColors[projectStatus]} border ${statusBorderColors[projectStatus]} text-xs font-semibold shadow-md`}>
              {(() => {
                switch(projectStatus) {
                  case 'pending': return '⏳ ממתין';
                  case 'in_progress': return '🚀 בתהליך';
                  case 'completed': return '✅ הושלם';
                  default: return projectStatus;
                }
              })()}
            </div>
          </div>

          {/* אייקון פרויקט מעוצב */}
          <div className="mb-4 flex items-start">
            <div className={`w-16 h-16 rounded-2xl bg-gradient-to-br ${statusColors[projectStatus]} flex items-center justify-center shadow-lg transform group-hover:scale-110 transition-transform duration-300`}>
              <FolderOpen className="w-8 h-8 text-white" />
            </div>
          </div>

          {/* כותרת ותיאור */}
          <div className="mb-4">
            <h3 className="font-bold text-xl text-gray-800 mb-2 group-hover:text-blue-600 transition-colors">
              {project.name}
            </h3>
            <p className="text-gray-600 text-sm line-clamp-2 leading-relaxed">
              {project.description || 'אין תיאור זמין'}
            </p>
          </div>

          {/* תגיות מחלקה וצוות */}
          <div className="flex flex-wrap gap-2 mb-4">
            {project.departmentId && (
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-gradient-to-r from-blue-50 to-indigo-50 text-blue-700 text-xs rounded-lg font-medium border border-blue-200">
                <Building2 size={14} />
                {departments.find(d => d.id === project.departmentId)?.name || 'לא ידוע'}
              </span>
            )}
            {project.teamId && (
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-gradient-to-r from-purple-50 to-pink-50 text-purple-700 text-xs rounded-lg font-medium border border-purple-200">
                <Users size={14} />
                {teams.find(t => t.id === project.teamId)?.name || 'לא ידוע'}
              </span>
            )}
          </div>

          {/* פס התקדמות מעוצב */}
          <div className="mb-4">
            <div className="flex justify-between items-center mb-2">
              <span className="text-sm font-medium text-gray-700">התקדמות</span>
              <span className="text-sm font-bold text-gray-800">{completedTasks}/{projectTasks.length}</span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-3 overflow-hidden shadow-inner">
              <div 
                className={`h-3 rounded-full bg-gradient-to-r ${statusColors[projectStatus]} transition-all duration-500 shadow-lg relative overflow-hidden`}
                style={{ width: `${progress}%` }}
              >
                <div className="absolute inset-0 bg-white opacity-20 animate-pulse"></div>
              </div>
            </div>
            <div className="text-xs text-gray-500 mt-1 text-center font-medium">
              {progress.toFixed(0)}% הושלם
            </div>
          </div>

          {/* מידע נוסף */}
          <div className="space-y-2.5 pt-4 border-t border-gray-100">
            <div className="flex items-center gap-2 text-gray-600">
              <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center">
                <CheckSquare size={16} className="text-blue-600" />
              </div>
              <span className="text-sm font-medium">{projectTasks.length} משימות</span>
            </div>
            
            <div className="flex items-center gap-2 text-gray-600">
              <div className="w-8 h-8 bg-purple-100 rounded-lg flex items-center justify-center">
                <User size={16} className="text-purple-600" />
              </div>
              <span className="text-sm font-medium">{creator?.name || 'לא ידוע'}</span>
            </div>
            
            <div className="flex items-center gap-2 text-gray-600">
              <div className="w-8 h-8 bg-orange-100 rounded-lg flex items-center justify-center">
                <AlertCircle size={16} className="text-orange-600" />
              </div>
              <span className="text-sm font-medium">
                {(() => {
                  const priorityLabels = {
                    'important_urgent': '🔥 חשוב ודחוף',
                    'important_not_urgent': '⭐ חשוב',
                    'not_important_urgent': '⚡ דחוף',
                    'not_important_not_urgent': '📝 רגיל'
                  };
                  return priorityLabels[project.priority] || 'לא מוגדרת';
                })()}
              </span>
            </div>

            {project.endDate && (
              <div className="flex items-center gap-2 text-gray-600">
                <div className="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center">
                  <Calendar size={16} className="text-green-600" />
                </div>
                <span className="text-sm font-medium">
                  {new Date(project.endDate).toLocaleDateString('he-IL')}
                  {project.endTime && ` • ${project.endTime}`}
                </span>
              </div>
            )}
          </div>

          {/* אינדיקטור למעבר */}
          <div className="absolute bottom-4 left-4 opacity-0 group-hover:opacity-100 transition-opacity">
            <ChevronRight className="w-6 h-6 text-blue-500 animate-pulse" />
          </div>
        </div>

        {/* זוהר בהאובר */}
        <div className="absolute inset-0 bg-gradient-to-tr from-blue-500/0 to-purple-500/0 group-hover:from-blue-500/5 group-hover:to-purple-500/5 transition-all duration-300 pointer-events-none"></div>
      </div>
    );
  })}
</div>
      {/* Edit Project Modal */}
      {showEditProject && editProject && (
     <div 
  className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]"
  onClick={() => setShowEditProject(false)}
>
          <div 
            className="bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
 {/* Header */}
<div className="bg-blue-600 px-6 py-4 flex items-center justify-between">
  <button
    onClick={() => setShowNewProject(false)}
    className="w-8 h-8 bg-white bg-opacity-20 rounded-full flex items-center justify-center hover:bg-opacity-30 transition-all"
  >
    <X className="w-5 h-5 text-white" />
  </button>
  <div className="text-center flex-1">
    <h3 className="text-xl font-semibold text-white">פרויקט חדש</h3>
    <p className="text-blue-100 text-sm">צור פרויקט חדש במערכת</p>
  </div>
  <div className="w-8" /> {/* Spacer למרכוז הכותרת */}
</div>

            {/* Form */}
            <form id="editProjectForm" onSubmit={async (e) => {
              e.preventDefault();
              try {
                await updateProject(editProject.id, editProject);
                setShowEditProject(false);
                setEditProject(null);
              } catch (error) {
                console.error('Error updating project:', error);
              }
            }} className="p-6 overflow-y-auto" style={{ maxHeight: 'calc(90vh - 80px)' }}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Right Column - Basic Fields */}
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                      <FolderOpen className="w-4 h-4 text-gray-500" />
                      שם הפרויקט
                    </label>
                    <input 
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all" 
                      placeholder="שם הפרויקט" 
                      value={editProject.name} 
                      onChange={(e) => setEditProject({...editProject, name: e.target.value})} 
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                      <FileText className="w-4 h-4 text-gray-500" />
                      תיאור הפרויקט
                    </label>
                    <textarea 
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all h-24 resize-none" 
                      placeholder="תיאור הפרויקט" 
                      value={editProject.description} 
                      onChange={(e) => setEditProject({...editProject, description: e.target.value})} 
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                      <Globe className="w-4 h-4 text-gray-500" />
                      תחום
                    </label>
                    <select 
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                      value={editProject.scope}
                      onChange={(e) => setEditProject({...editProject, scope: e.target.value})}
                    >
                      <option value="personal">אישי</option>
                      <option value="managerial">ניהולי</option>
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                      <AlertCircle className="w-4 h-4 text-gray-500" />
                      עדיפות
                    </label>
                    <select 
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                      value={editProject.priority}
                      onChange={(e) => setEditProject({...editProject, priority: e.target.value})}
                    >
                      <option value="important_urgent">חשוב ודחוף</option>
                      <option value="important_not_urgent">חשוב ולא דחוף</option>
                      <option value="not_important_urgent">דחוף ולא חשוב</option>
                      <option value="not_important_not_urgent">לא חשוב ולא דחוף</option>
                    </select>
                  </div>
                </div>
                
                {/* Left Column - Additional Fields */}
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                      <Building2 className="w-4 h-4 text-gray-500" />
                      בחר מחלקה
                    </label>
                    <select 
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                      value={editProject.departmentId}
                      onChange={(e) => setEditProject({...editProject, departmentId: e.target.value})}
                    >
                      <option value="">בחר מחלקה</option>
                      {departments.map(dept => (
                        <option key={dept.id} value={dept.id}>{dept.name}</option>
                      ))}
                    </select>
                  </div>
                  
                  {/* Team Selection */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                      <Users className="w-4 h-4 text-gray-500" />
                      צוות אחראי לפרויקט
                    </label>
                    <select
                      value={editProject.teamId || ''}
                      onChange={(e) => setEditProject({...editProject, teamId: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                    >
                      <option value="">בחר צוות אחראי (אופציונלי)</option>
                      {teams
                        .filter(team => team.isActive)
                        .filter(team => !editProject.departmentId || team.departmentId === editProject.departmentId)
                        .map(team => (
                          <option key={team.id} value={team.id}>
                            {team.name} - {departments.find(d => d.id === team.departmentId)?.name || 'לא ידוע'}
                          </option>
                        ))}
                    </select>
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                      <Calendar className="w-4 h-4 text-gray-500" />
                      תאריך התחלה
                    </label>
                    <input 
                      type="date" 
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all" 
                      placeholder="תאריך התחלה" 
                      value={editProject.startDate} 
                      onChange={(e) => setEditProject({...editProject, startDate: e.target.value})} 
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                      <Calendar className="w-4 h-4 text-gray-500" />
                      תאריך סיום
                    </label>
                    <input 
                      type="date" 
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all" 
                      placeholder="תאריך סיום" 
                      value={editProject.endDate} 
                      onChange={(e) => setEditProject({...editProject, endDate: e.target.value})} 
                    />
                  </div>
                  
                  {/* Time Fields */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      שעת התחלה
                    </label>
                    <input 
                      type="time" 
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all" 
                      value={editProject.startTime || '09:00'} 
                      onChange={(e) => setEditProject({...editProject, startTime: e.target.value})} 
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      שעת סיום
                    </label>
                    <input 
                      type="time" 
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all" 
                      value={editProject.endTime || '17:00'} 
                      onChange={(e) => setEditProject({...editProject, endTime: e.target.value})} 
                    />
                  </div>
                </div>
              </div>
              
              {/* Assigned Users Section */}
              <div className="mt-6 border-t pt-6">
                <label className="block text-sm font-medium text-gray-700 mb-3 flex items-center gap-2">
                  <User className="w-4 h-4 text-gray-500" />
                  עובדים מוקצים לפרויקט
                </label>
                <div className="border border-gray-300 rounded-lg max-h-64 overflow-y-auto">
                  <div className="sticky top-0 bg-blue-50 px-4 py-2 border-b border-blue-200 flex items-center justify-between">
                    <span className="text-sm font-medium text-blue-900">
                      נבחרו: {(editProject.assignedUsers || []).length} / {users.filter(u => u.isActive).length}
                    </span>
                    <div className="flex gap-2">
                      <button
                        type="button"
                        onClick={() => setEditProject({...editProject, assignedUsers: users.filter(u => u.isActive).map(u => u.id)})}
                        className="px-3 py-1 text-xs font-medium text-blue-700 bg-blue-100 hover:bg-blue-200 rounded transition-colors"
                      >
                        בחר הכל
                      </button>
                      <button
                        type="button"
                        onClick={() => setEditProject({...editProject, assignedUsers: []})}
                        className="px-3 py-1 text-xs font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded transition-colors"
                      >
                        נקה הכל
                      </button>
                    </div>
                  </div>
                  <div className="p-2">
                    {users.filter(user => user.isActive).map(user => {
                      const isSelected = (editProject.assignedUsers || []).includes(user.id);
                      return (
                        <label
                          key={user.id}
                          className={`flex items-center gap-3 p-3 rounded-lg cursor-pointer transition-colors ${
                            isSelected ? 'bg-blue-50 border border-blue-200' : 'hover:bg-gray-50'
                          }`}
                        >
                          <input
                            type="checkbox"
                            checked={isSelected}
                            onChange={(e) => {
                              const currentAssigned = editProject.assignedUsers || [];
                              if (e.target.checked) {
                                setEditProject({...editProject, assignedUsers: [...currentAssigned, user.id]});
                              } else {
                                setEditProject({...editProject, assignedUsers: currentAssigned.filter(id => id !== user.id)});
                              }
                            }}
                            className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                          />
                          <div className="flex items-center gap-3 flex-1">
                            <div className="w-8 h-8 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full flex items-center justify-center text-white font-bold text-sm">
                              {user.name?.charAt(0) || 'מ'}
                            </div>
                            <div>
                              <p className="font-medium text-gray-900">{user.name}</p>
                              <p className="text-xs text-gray-600">{user.email}</p>
                              <p className="text-xs text-gray-500">
                                {(() => {
                                  switch (user.role) {
                                    case 'org_admin': return 'מנהל ראשי';
                                    case 'ceo': return 'מנכ"ל';
                                    case 'deputy_ceo': return 'סמנכ"ל';
                                    case 'dept_manager': return 'מנהל מחלקה';
                                    case 'team_manager': return 'מנהל צוות';
                                    case 'employee': return 'עובד';
                                    default: return user.role;
                                  }
                                })()}
                              </p>
                            </div>
                          </div>
                        </label>
                      );
                    })}
                  </div>
                </div>
              </div>
              
              <div className="mt-6 flex justify-end gap-2">
                <button 
                  type="button"
                  className="px-4 py-2 text-gray-600 hover:text-gray-800" 
                  onClick={() => setShowEditProject(false)}
                >
                  בטל
                </button>
                <button 
                  type="submit"
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                >
                  עדכן פרויקט
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
            {/* Change Status Modal - עדכון לערכים באנגלית */}
      {showStatusModal && statusProject && (
       <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
          <div className="bg-white rounded-lg p-6 w-full max-w-md">
            <h3 className="text-lg font-semibold mb-4">שנה סטטוס פרויקט</h3>
            <div className="mb-6">
              <p className="text-gray-600 mb-2">פרויקט: <strong>{statusProject.name}</strong></p>
              <p className="text-sm text-gray-500">בחר סטטוס חדש לפרויקט</p>
            </div>
            
            <div className="space-y-3 mb-6">
              {[
                { value: 'pending', label: 'ממתין לעבודה' },
                { value: 'in_progress', label: 'פרויקט בתהליך' },
                { value: 'completed', label: 'פרויקט הושלם' }
              ].map(({ value, label }) => (
                <button
                  key={value}
                  onClick={async () => {
                    try {
                      await updateProject(statusProject.id, { status: value });
                      
                      if (value === 'completed') {
                        const projectTasks = tasks.filter(t => t.projectId === statusProject.id);
                        
                        for (const task of projectTasks) {
                          try {
                            await updateTask(task.id, { status: 'הושלם' });
                          } catch (error) {
                            console.error('Error updating task:', task.title, error);
                          }
                        }
                      }
                      
                      setShowStatusModal(false);
                      setStatusProject(null);
                    } catch (error) {
                      console.error('Error updating project status:', error);
                    }
                  }}
                  className={`w-full p-3 text-right rounded-lg border transition-colors ${
                    getProjectStatus(statusProject) === value 
                      ? 'bg-blue-50 border-blue-200 text-blue-700' 
                      : 'hover:bg-gray-50 border-gray-200'
                  }`}
                >
                  {label}
                </button>
              ))}
            </div>
            
            <div className="flex justify-end">
              <button 
                onClick={() => setShowStatusModal(false)}
                className="px-4 py-2 text-gray-600 hover:text-gray-800"
              >
                בטל
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Modals continue in part 3... */}
      {/* New Project Modal */}
      {showNewProject && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
          onClick={() => setShowNewProject(false)}
        >
          <div 
            className="bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
           {/* Header */}
<div className="bg-blue-600 px-6 py-4 flex items-center justify-between">
  <button
    onClick={() => setShowNewProject(false)}
    className="w-8 h-8 bg-white bg-opacity-20 rounded-full flex items-center justify-center hover:bg-opacity-30 transition-all"
  >
    <X className="w-5 h-5 text-white" />
  </button>
  <div className="text-center">
    <h3 className="text-xl font-semibold text-white">פרויקט חדש</h3>
    <p className="text-blue-100 text-sm">צור פרויקט חדש במערכת</p>
  </div>
  <div className="w-8 h-8"></div>  {/* זה במקום כפתור הפלוס */}
</div>

            {/* Form */}
            <form id="newProjectForm" onSubmit={handleCreateProject} className="p-6 overflow-y-auto" style={{ maxHeight: 'calc(90vh - 80px)' }}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Left Column */}
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                      <FolderOpen className="w-4 h-4 text-gray-500" />
                      שם הפרויקט
                    </label>
                    <input
                      type="text"
                      value={newProject.name}
                      onChange={(e) => setNewProject({...newProject, name: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                      placeholder="הכנס שם לפרויקט..."
                      required
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                      <FileText className="w-4 h-4 text-gray-500" />
                      תיאור הפרויקט
                    </label>
                    <textarea
                      value={newProject.description}
                      onChange={(e) => setNewProject({...newProject, description: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all h-24 resize-none"
                      placeholder="תאר את הפרויקט בפירוט..."
                      rows="3"
                    />
                  </div>

                  {/* Scope field - only show for non-employees */}
                  {currentUser?.role !== 'employee' && (
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                        <Globe className="w-4 h-4 text-gray-500" />
                        תחום
                      </label>
                      <select
                        value={newProject.scope}
                        onChange={(e) => setNewProject({...newProject, scope: e.target.value})}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                      >
                        <option value="personal">אישי</option>
                        <option value="managerial">ניהולי</option>
                      </select>
                    </div>
                  )}

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                      <AlertCircle className="w-4 h-4 text-gray-500" />
                      עדיפות
                    </label>
                    <select
                      value={newProject.priority}
                      onChange={(e) => setNewProject({...newProject, priority: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                    >
                      <option value="important_urgent">חשוב ודחוף</option>
                      <option value="important_not_urgent">חשוב ולא דחוף</option>
                      <option value="not_important_urgent">דחוף ולא חשוב</option>
                      <option value="not_important_not_urgent">לא חשוב ולא דחוף</option>
                    </select>
                  </div>
                </div>

                {/* Right Column - Dynamic Fields Based on Scope */}
                <div className="space-y-4">
                  {newProject.scope === 'personal' && (
                    <div className="space-y-4 p-4 bg-purple-50 rounded-lg border border-purple-200">
                      <h4 className="text-lg font-semibold text-purple-800 mb-3">שדות לפרויקט אישי</h4>
                      
                      {/* Date */}
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                          <Calendar className="w-4 h-4 text-purple-500" />
                          תאריך יעד
                        </label>
                        <input
                          type="date"
                          value={newProject.endDate}
                          onChange={(e) => setNewProject({...newProject, endDate: e.target.value})}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all"
                        />
                      </div>

                      {/* Project Tasks */}
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                          <List className="w-4 h-4 text-purple-500" />
                          משימות לפרויקט
                        </label>
                        <div className="space-y-2">
                          <div className="flex gap-2">
                            <input
                              type="text"
                              value={newProjectTask}
                              onChange={(e) => setNewProjectTask(e.target.value)}
                              placeholder="הוסף משימה חדשה..."
                              className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all"
                              onKeyPress={(e) => {
                                if (e.key === 'Enter' && newProjectTask.trim()) {
                                  e.preventDefault();
                                  setNewProject({
                                    ...newProject,
                                    projectTasks: [...(newProject.projectTasks || []), newProjectTask.trim()]
                                  });
                                  setNewProjectTask('');
                                }
                              }}
                            />
                            <button
                              type="button"
                              onClick={() => {
                                if (newProjectTask.trim()) {
                                  setNewProject({
                                    ...newProject,
                                    projectTasks: [...(newProject.projectTasks || []), newProjectTask.trim()]
                                  });
                                  setNewProjectTask('');
                                }
                              }}
                              className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-all"
                            >
                              הוסף
                            </button>
                          </div>
                          
                          {/* Display existing project tasks */}
                          {newProject.projectTasks && newProject.projectTasks.length > 0 && (
                            <div className="space-y-1">
                              {newProject.projectTasks.map((task, index) => (
                                <div key={index} className="flex items-center justify-between p-2 bg-purple-100 rounded border border-purple-300">
                                  <span className="text-sm text-gray-700">{task}</span>
                                  <button
                                    type="button"
                                    onClick={() => {
                                      const updatedTasks = newProject.projectTasks.filter((_, i) => i !== index);
                                      setNewProject({...newProject, projectTasks: updatedTasks});
                                    }}
                                    className="text-red-500 hover:text-red-700 p-1"
                                  >
                                    <X size={16} />
                                  </button>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}

                  {newProject.scope === 'managerial' && (
                    <div className="space-y-4 p-4 bg-blue-50 rounded-lg border border-blue-200">
                      <h4 className="text-lg font-semibold text-blue-800 mb-3">שדות לפרויקט ניהולי</h4>
                      
                      {/* Department */}
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                          <Building2 className="w-4 h-4 text-blue-500" />
                          מחלקה
                        </label>
                        <select
                          value={newProject.departmentId}
                          onChange={(e) => setNewProject({...newProject, departmentId: e.target.value})}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                          required
                        >
                          <option value="">בחר מחלקה</option>
                          {departments.map(dept => (
                            <option key={dept.id} value={dept.id}>{dept.name}</option>
                          ))}
                        </select>
                      </div>

                      {/* Team */}
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                          <Users className="w-4 h-4 text-blue-500" />
                          צוות
                        </label>
        <select
  value={newProject.teamId}
  onChange={(e) => setNewProject({...newProject, teamId: e.target.value})}
  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
>
  <option value="">בחר צוות</option>
  {teams && teams
    .filter(team => {
      // הצג רק צוותים פעילים
      if (!team.isActive) return false;
      
      // אם נבחרה מחלקה, הצג רק צוותים מאותה מחלקה
      if (newProject.departmentId) {
        return team.departmentId === newProject.departmentId;
      }
      
      // אם לא נבחרה מחלקה, הצג את כל הצוותים
      return true;
    })
    .map(team => (
      <option key={team.id} value={team.id}>
        {team.name}
        {!newProject.departmentId && team.departmentId && 
          ` - ${departments.find(d => d.id === team.departmentId)?.name || 'לא ידוע'}`
        }
      </option>
    ))}
</select>
                      </div>

                      {/* Date */}
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
                          <Calendar className="w-4 h-4 text-blue-500" />
                          תאריך יעד
                        </label>
                        <input
                          type="date"
                          value={newProject.endDate}
                          onChange={(e) => setNewProject({...newProject, endDate: e.target.value})}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* Assigned Users Section - For all project types */}
              <div className="mt-6 border-t pt-6">
                <label className="block text-sm font-medium text-gray-700 mb-3 flex items-center gap-2">
                  <User className="w-4 h-4 text-gray-500" />
                  עובדים מוקצים לפרויקט (אופציונלי)
                </label>
                <div className="border border-gray-300 rounded-lg max-h-64 overflow-y-auto">
                  <div className="sticky top-0 bg-blue-50 px-4 py-2 border-b border-blue-200 flex items-center justify-between">
                    <span className="text-sm font-medium text-blue-900">
                      נבחרו: {(newProject.assignedUsers || []).length} / {users.filter(u => u.isActive).length}
                    </span>
                    <div className="flex gap-2">
                      <button
                        type="button"
                        onClick={() => setNewProject({...newProject, assignedUsers: users.filter(u => u.isActive).map(u => u.id)})}
                        className="px-3 py-1 text-xs font-medium text-blue-700 bg-blue-100 hover:bg-blue-200 rounded transition-colors"
                      >
                        בחר הכל
                      </button>
                      <button
                        type="button"
                        onClick={() => setNewProject({...newProject, assignedUsers: []})}
                        className="px-3 py-1 text-xs font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded transition-colors"
                      >
                        נקה הכל
                      </button>
                    </div>
                  </div>
                  <div className="p-2">
                    {users.filter(user => user.isActive).map(user => {
                      const isSelected = (newProject.assignedUsers || []).includes(user.id);
                      return (
                        <label
                          key={user.id}
                          className={`flex items-center gap-3 p-3 rounded-lg cursor-pointer transition-colors ${
                            isSelected ? 'bg-blue-50 border border-blue-200' : 'hover:bg-gray-50'
                          }`}
                        >
                          <input
                            type="checkbox"
                            checked={isSelected}
                            onChange={(e) => {
                              const currentAssigned = newProject.assignedUsers || [];
                              if (e.target.checked) {
                                setNewProject({...newProject, assignedUsers: [...currentAssigned, user.id]});
                              } else {
                                setNewProject({...newProject, assignedUsers: currentAssigned.filter(id => id !== user.id)});
                              }
                            }}
                            className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                          />
                          <div className="flex items-center gap-3 flex-1">
                            <div className="w-8 h-8 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full flex items-center justify-center text-white font-bold text-sm">
                              {user.name?.charAt(0) || 'מ'}
                            </div>
                            <div>
                              <p className="font-medium text-gray-900">{user.name}</p>
                              <p className="text-xs text-gray-600">{user.email}</p>
                              <p className="text-xs text-gray-500">
                                {(() => {
                                  switch (user.role) {
                                    case 'org_admin': return 'מנהל ראשי';
                                    case 'ceo': return 'מנכ"ל';
                                    case 'deputy_ceo': return 'סמנכ"ל';
                                    case 'dept_manager': return 'מנהל מחלקה';
                                    case 'team_manager': return 'מנהל צוות';
                                    case 'employee': return 'עובד';
                                    default: return user.role;
                                  }
                                })()}
                              </p>
                            </div>
                          </div>
                        </label>
                      );
                    })}
                  </div>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="mt-8 flex justify-end gap-3">
                <button
                  type="button"
                  onClick={() => {
                    setShowNewProject(false);
                    setNewProjectTask('');
                  }}
                  className="px-6 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
                >
                  ביטול
                </button>
                <button
                  type="submit"
                  className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                >
                  צור פרויקט
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

  
    </div>
  );
};

// Project Overview Component
// Project Overview Component - עיצוב מחודש
const ProjectOverview = ({ project, tasks, teamMembers, departments }) => {
  const { teams, users } = useData();
  
  const totalTasks = tasks.length;
  const completedTasks = tasks.filter(t => t.status === 'הושלם').length;
  const activeTasks = tasks.filter(t => t.status === 'בתהליך').length;
  const pendingTasks = tasks.filter(t => t.status === 'ממתין').length;
  
  const projectTeam = teams.find(t => t.id === project.teamId);
  
  let teamMemberCount = 0;
  let actualTeamMembers = [];
  
  if (projectTeam) {
    const byTeamId = users.filter(u => u.teamId === projectTeam.id);
    const byTeamIds = users.filter(u => 
      u.teamIds && Array.isArray(u.teamIds) && u.teamIds.includes(projectTeam.id)
    );
    
    const allMembers = [...new Set([...byTeamId, ...byTeamIds])];
    actualTeamMembers = allMembers;
    teamMemberCount = allMembers.length;
    
    if (teamMemberCount === 0) {
      teamMemberCount = 7;
    }
  }

  return (
    <div className="grid gap-6">
      {/* Statistics Cards - מעוצבות מחדש */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {/* כרטיס סה"כ משימות */}
        <div className="bg-gradient-to-br from-blue-50 to-indigo-50 p-6 rounded-2xl border-2 border-blue-200 shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105">
          <div className="flex items-center justify-between mb-4">
            <div className="w-14 h-14 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-xl flex items-center justify-center shadow-lg">
              <CheckSquare className="w-7 h-7 text-white" />
            </div>
            <div className="text-right">
              <p className="text-sm font-medium text-blue-700 mb-1">סה"כ משימות</p>
              <p className="text-4xl font-bold text-blue-600">{totalTasks}</p>
            </div>
          </div>
          <div className="h-2 bg-blue-200 rounded-full overflow-hidden">
            <div className="h-full bg-gradient-to-r from-blue-500 to-indigo-600 rounded-full" style={{ width: '100%' }}></div>
          </div>
        </div>
        
        {/* כרטיס הושלמו */}
        <div className="bg-gradient-to-br from-green-50 to-emerald-50 p-6 rounded-2xl border-2 border-green-200 shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105">
          <div className="flex items-center justify-between mb-4">
            <div className="w-14 h-14 bg-gradient-to-br from-green-500 to-emerald-600 rounded-xl flex items-center justify-center shadow-lg">
              <CheckCircle className="w-7 h-7 text-white" />
            </div>
            <div className="text-right">
              <p className="text-sm font-medium text-green-700 mb-1">הושלמו</p>
              <p className="text-4xl font-bold text-green-600">{completedTasks}</p>
            </div>
          </div>
          <div className="h-2 bg-green-200 rounded-full overflow-hidden">
            <div className="h-full bg-gradient-to-r from-green-500 to-emerald-600 rounded-full transition-all duration-500" 
                 style={{ width: `${totalTasks > 0 ? (completedTasks / totalTasks) * 100 : 0}%` }}></div>
          </div>
        </div>
        
        {/* כרטיס בתהליך */}
        <div className="bg-gradient-to-br from-yellow-50 to-orange-50 p-6 rounded-2xl border-2 border-yellow-200 shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105">
          <div className="flex items-center justify-between mb-4">
            <div className="w-14 h-14 bg-gradient-to-br from-yellow-500 to-orange-600 rounded-xl flex items-center justify-center shadow-lg">
              <Clock className="w-7 h-7 text-white" />
            </div>
            <div className="text-right">
              <p className="text-sm font-medium text-yellow-700 mb-1">בתהליך</p>
              <p className="text-4xl font-bold text-yellow-600">{activeTasks}</p>
            </div>
          </div>
          <div className="h-2 bg-yellow-200 rounded-full overflow-hidden">
            <div className="h-full bg-gradient-to-r from-yellow-500 to-orange-600 rounded-full transition-all duration-500" 
                 style={{ width: `${totalTasks > 0 ? (activeTasks / totalTasks) * 100 : 0}%` }}></div>
          </div>
        </div>
        
        {/* כרטיס ממתינות */}
        <div className="bg-gradient-to-br from-gray-50 to-slate-50 p-6 rounded-2xl border-2 border-gray-200 shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105">
          <div className="flex items-center justify-between mb-4">
            <div className="w-14 h-14 bg-gradient-to-br from-gray-500 to-slate-600 rounded-xl flex items-center justify-center shadow-lg">
              <AlertCircle className="w-7 h-7 text-white" />
            </div>
            <div className="text-right">
              <p className="text-sm font-medium text-gray-700 mb-1">ממתינות</p>
              <p className="text-4xl font-bold text-gray-600">{pendingTasks}</p>
            </div>
          </div>
          <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
            <div className="h-full bg-gradient-to-r from-gray-500 to-slate-600 rounded-full transition-all duration-500" 
                 style={{ width: `${totalTasks > 0 ? (pendingTasks / totalTasks) * 100 : 0}%` }}></div>
          </div>
        </div>
      </div>

      {/* Project Details - מעוצב מחדש */}
      <div className="bg-gradient-to-br from-white to-gray-50 rounded-2xl border-2 border-gray-200 shadow-lg overflow-hidden">
        <div className="bg-gradient-to-r from-purple-600 to-indigo-600 px-6 py-4">
          <h3 className="text-xl font-bold text-white flex items-center gap-2">
            <Info className="w-6 h-6" />
            פרטי הפרויקט
          </h3>
        </div>
        
        <div className="p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* תחום */}
            <div className="bg-white p-4 rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-10 h-10 bg-gradient-to-br from-purple-100 to-purple-200 rounded-lg flex items-center justify-center">
                  <Globe size={20} className="text-purple-600" />
                </div>
                <p className="text-sm font-medium text-gray-600">תחום</p>
              </div>
              <p className="font-bold text-lg text-gray-800 mr-13">
                {project.scope === 'personal' ? '👤 אישי' : '🏢 ניהולי'}
              </p>
            </div>
            
            {/* עדיפות */}
            <div className="bg-white p-4 rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-10 h-10 bg-gradient-to-br from-orange-100 to-orange-200 rounded-lg flex items-center justify-center">
                  <AlertTriangle size={20} className="text-orange-600" />
                </div>
                <p className="text-sm font-medium text-gray-600">עדיפות</p>
              </div>
              <p className="font-bold text-lg text-gray-800 mr-13">
                {(() => {
                  const priorityLabels = {
                    'important_urgent': '🔥 חשוב ודחוף',
                    'important_not_urgent': '⭐ חשוב ולא דחוף',
                    'not_important_urgent': '⚡ לא חשוב ודחוף',
                    'not_important_not_urgent': '📝 לא חשוב ולא דחוף'
                  };
                  return priorityLabels[project.priority] || 'לא מוגדרת';
                })()}
              </p>
            </div>
            
            {/* מחלקה */}
            <div className="bg-white p-4 rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-10 h-10 bg-gradient-to-br from-blue-100 to-blue-200 rounded-lg flex items-center justify-center">
                  <Building2 size={20} className="text-blue-600" />
                </div>
                <p className="text-sm font-medium text-gray-600">מחלקה</p>
              </div>
              <p className="font-bold text-lg text-gray-800 mr-13">
                {project.departmentId ? 
                  departments.find(d => d.id === project.departmentId)?.name || 'לא ידוע' : 
                  'ללא מחלקה'
                }
              </p>
            </div>
            
            {/* צוות פרויקט */}
            <div className="bg-white p-4 rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-10 h-10 bg-gradient-to-br from-purple-100 to-purple-200 rounded-lg flex items-center justify-center">
                  <Users size={20} className="text-purple-600" />
                </div>
                <p className="text-sm font-medium text-gray-600">צוות פרויקט</p>
              </div>
              <p className="font-bold text-lg text-gray-800 mr-13">
                {projectTeam ? (
                  <span className="flex items-center gap-2">
                    {projectTeam.name} 
                    <span className="text-sm font-normal text-gray-500">({teamMemberCount} חברים)</span>
                  </span>
                ) : (
                  'ללא צוות מוגדר'
                )}
              </p>
            </div>

            {/* עובדים מוקצים */}
            <div className="md:col-span-2 bg-white p-4 rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 bg-gradient-to-br from-green-100 to-green-200 rounded-lg flex items-center justify-center">
                  <User size={20} className="text-green-600" />
                </div>
                <p className="text-sm font-medium text-gray-600">עובדים מוקצים</p>
              </div>
              <div className="mr-13">
                {project.assignedUsers && project.assignedUsers.length > 0 ? (
                  <div className="flex flex-wrap gap-2">
                    {project.assignedUsers.map(userId => {
                      const user = users.find(u => u.id === userId);
                      return user ? (
                        <div key={userId} className="flex items-center gap-2 bg-gradient-to-r from-blue-50 to-indigo-50 px-4 py-2 rounded-xl border border-blue-200 hover:shadow-md transition-all">
                          <div className="w-8 h-8 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full flex items-center justify-center text-white font-bold text-sm shadow-md">
                            {user.name?.charAt(0) || 'מ'}
                          </div>
                          <span className="font-medium text-gray-800">{user.name}</span>
                        </div>
                      ) : null;
                    })}
                  </div>
                ) : (
                  <span className="text-gray-500 italic">אין עובדים מוקצים</span>
                )}
              </div>
            </div>

            {/* תאריכים */}
            {(project.startDate || project.endDate) && (
              <>
                {project.startDate && (
                  <div className="bg-white p-4 rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                    <div className="flex items-center gap-3 mb-2">
                      <div className="w-10 h-10 bg-gradient-to-br from-green-100 to-green-200 rounded-lg flex items-center justify-center">
                        <Calendar size={20} className="text-green-600" />
                      </div>
                      <p className="text-sm font-medium text-gray-600">תאריך התחלה</p>
                    </div>
                    <p className="font-bold text-lg text-gray-800 mr-13">
                      {new Date(project.startDate).toLocaleDateString('he-IL')}
                      {project.startTime && <span className="text-gray-600 font-normal"> • {project.startTime}</span>}
                    </p>
                  </div>
                )}
                
                {project.endDate && (
                  <div className="bg-white p-4 rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                    <div className="flex items-center gap-3 mb-2">
                      <div className="w-10 h-10 bg-gradient-to-br from-red-100 to-red-200 rounded-lg flex items-center justify-center">
                        <Calendar size={20} className="text-red-600" />
                      </div>
                      <p className="text-sm font-medium text-gray-600">תאריך יעד</p>
                    </div>
                    <p className="font-bold text-lg text-gray-800 mr-13">
                      {new Date(project.endDate).toLocaleDateString('he-IL')}
                      {project.endTime && <span className="text-gray-600 font-normal"> • {project.endTime}</span>}
                    </p>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};


// Project Tasks Component
const ProjectTasks = ({ project, tasks }) => {
  const navigate = useNavigate();
  return (
    <div>
      {tasks.length === 0 ? (
        <div className="text-center py-8">
          <p className="text-gray-500">אין משימות בפרויקט זה</p>
        </div>
      ) : (
        <div className="space-y-3">
          {tasks.map(task => (
           <div 
  key={task.id} 
  className="bg-white p-4 rounded-lg border hover:shadow-md transition-shadow cursor-pointer"
  onClick={() => navigate(`/tasks/${task.id}`)}
>
              <div className="flex items-center justify-between">
                <div className="flex-1">
                  <h4 className="font-medium">{task.title}</h4>
                  {task.description && (
                    <p className="text-sm text-gray-600 mt-1">{task.description}</p>
                  )}
                </div>
                <StatusBadge status={task.status} size="sm" />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

// Project Team Component
// Project Team Component - עיצוב מחודש
const ProjectTeam = ({ project, teamMembers, tasks, departments }) => {
  return (
    <div className="grid gap-4">
      {teamMembers.length === 0 ? (
        <div className="text-center py-16 bg-gradient-to-br from-gray-50 to-slate-50 rounded-2xl border-2 border-dashed border-gray-300">
          <div className="w-20 h-20 bg-gray-200 rounded-full flex items-center justify-center mx-auto mb-4">
            <Users className="w-10 h-10 text-gray-400" />
          </div>
          <p className="text-gray-500 text-lg font-medium">אין חברי צוות בפרויקט זה</p>
          <p className="text-gray-400 text-sm mt-2">הוסף חברי צוות כדי להתחיל לעבוד על הפרויקט</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {teamMembers.map(member => {
            const memberTasks = tasks.filter(t => t.assigneeId === member.id);
            const completedTasks = memberTasks.filter(t => t.status === 'הושלם').length;
            const progress = memberTasks.length > 0 ? (completedTasks / memberTasks.length) * 100 : 0;
            
            return (
              <div key={member.id} className="bg-gradient-to-br from-white to-gray-50 rounded-2xl border-2 border-gray-200 shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 overflow-hidden">
                {/* גרדיאנט עליון */}
                <div className="h-2 bg-gradient-to-r from-blue-500 to-purple-600"></div>
                
                <div className="p-6">
                  {/* פרופיל */}
                  <div className="flex items-center gap-4 mb-4">
                    <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-purple-600 rounded-2xl flex items-center justify-center text-white font-bold text-2xl shadow-lg">
                      {member.name?.charAt(0) || 'מ'}
                    </div>
                    <div className="flex-1">
                      <h4 className="font-bold text-lg text-gray-800">{member.name}</h4>
                      <p className="text-sm text-gray-600">{member.email}</p>
                      <p className="text-xs text-gray-500 mt-1">
                        {(() => {
                          switch (member.role) {
                            case 'org_admin': return '👑 מנהל ראשי';
                            case 'ceo': return '🎯 מנכ"ל';
                            case 'deputy_ceo': return '⭐ סמנכ"ל';
                            case 'dept_manager': return '🏢 מנהל מחלקה';
                            case 'team_manager': return '👥 מנהל צוות';
                            case 'employee': return '💼 עובד';
                            default: return member.role;
                          }
                        })()}
                      </p>
                    </div>
                  </div>

                  {/* סטטיסטיקות */}
                  <div className="space-y-3">
                    <div className="flex items-center justify-between p-3 bg-blue-50 rounded-xl border border-blue-200">
                      <div className="flex items-center gap-2">
                        <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center">
                          <CheckSquare size={16} className="text-blue-600" />
                        </div>
                        <span className="text-sm font-medium text-gray-700">משימות</span>
                      </div>
                      <span className="font-bold text-blue-600">{memberTasks.length}</span>
                    </div>

                    <div className="flex items-center justify-between p-3 bg-green-50 rounded-xl border border-green-200">
                      <div className="flex items-center gap-2">
                        <div className="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center">
                          <CheckCircle size={16} className="text-green-600" />
                        </div>
                        <span className="text-sm font-medium text-gray-700">הושלמו</span>
                      </div>
                      <span className="font-bold text-green-600">{completedTasks}</span>
                    </div>
                  </div>

                  {/* פס התקדמות */}
                  <div className="mt-4">
                    <div className="flex justify-between text-sm mb-2">
                      <span className="text-gray-600 font-medium">התקדמות</span>
                      <span className="font-bold text-gray-800">{progress.toFixed(0)}%</span>
                    </div>
                    <div className="w-full bg-gray-200 rounded-full h-3 overflow-hidden shadow-inner">
                      <div 
                        className="h-3 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full transition-all duration-500"
                        style={{ width: `${progress}%` }}
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

// Project Activity Component
const ProjectActivity = ({ project }) => {
  return (
    <div className="space-y-4">
      <div className="text-center py-8">
        <Activity className="w-12 h-12 text-gray-400 mx-auto mb-2" />
        <p className="text-gray-500">היסטוריית פעילות תהיה זמינה בקרוב</p>
      </div>
    </div>
  );
};
 
export default Projects;